﻿package com.milta.core.localization.translations.fr

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Mon profil",
    sectionPersonal = "Informations personnelles",
    labelFirstName = "Prénom",
    labelLastName = "Nom",
    labelRole = "Rôle",
    sectionLanguage = "Langue",
    labelLanguage = "Langue de l'application",
    changeLanguageButton = "Changer la langue",
    languageDialogTitle = "Choisissez votre langue",
    languageDialogConfirm = "Confirmer",
    languageDialogCancel = "Annuler",
    sectionPassword = "Sécurité",
    labelCurrentPassword = "Mot de passe actuel",
    labelNewPassword = "Nouveau mot de passe",
    changePasswordButton = "Changer le mot de passe",
    successLanguageUpdated = "Langue mise à jour avec succès",
    successPasswordChanged = "Mot de passe changé avec succès",
    errorProfileNotFound = "Profil introuvable",
    errorCurrentPasswordRequired = "Veuillez entrer votre mot de passe actuel",
    errorCurrentPasswordTooLong = "Le mot de passe actuel ne peut pas dépasser 128 caractères",
    errorNewPasswordRequired = "Veuillez entrer un nouveau mot de passe",
    errorNewPasswordTooShort = "Le nouveau mot de passe doit contenir au moins 8 caractères",
    errorNewPasswordTooLong = "Le nouveau mot de passe ne peut pas dépasser 128 caractères",
    errorLanguageRequired = "Veuillez sélectionner une langue",
    errorForbidden = "Vous n'êtes pas autorisé à effectuer cette action",
    errorValidation = "Les données fournies sont invalides",
    errorGeneric = "Une erreur s'est produite. Veuillez réessayer.",
    signOut = "Se déconnecter",
    deleteAccount = "Supprimer mon compte",
    menuLanguage = "Langue d'interface",
    menuPassword = "Modifier le mot de passe",
    menuSubscription = "Mon abonnement",
    menuPrivacy = "Confidentialité & RGPD",
    linkedCodeLabel = "Code de liaison à usage unique",
    copyCode = "Copier",
    codeCopied = "Copié !",
    modeOrganisation = "Entreprise",
    modeDriver = "Livreur",
    roleDriver = "Livreur",
    roleOrganisation = "Entreprise",
    modeSwitchTitle = "Changer de mode",
    modeSwitchHint = "Basculez entre le mode Entreprise et le mode Livreur à tout moment",
    switchToEnterprise = "Mode Entreprise",
    switchToDriver = "Mode Livreur",
    menuPhone = "Numéro de téléphone",
    phoneOtpStepTitle = "Code de vérification envoyé par SMS",
    successPhoneUpdated = "Numéro de téléphone mis à jour",
    deleteAccountDialogTitle = "Supprimer votre compte ?",
    deleteAccountDialogMessage = "Cette action est irréversible. Vos informations personnelles seront supprimées. Un code de vérification va être envoyé par SMS pour confirmer.",
    deleteAccountDialogConfirm = "Continuer",
    deleteAccountOtpStepTitle = "Code de vérification envoyé par SMS",
    deleteAccountConfirmButton = "Supprimer définitivement",
    errorLastEnterpriseOwner = "Vous êtes le seul gestionnaire de votre entreprise. Ajoutez un autre compte Entreprise avant de supprimer le vôtre.",
    logoutPendingWarningTitle = "Livraisons non envoyées",
    logoutPendingWarningMessageSuffix = "livraison(s) en attente d'envoi seront perdues si vous vous déconnectez maintenant.",
    logoutPendingWarningConfirm = "Se déconnecter quand même",
    logoutPendingWarningCancel = "Annuler",
    modeSwitchActiveRouteWarningTitle = "Tournée en cours",
    modeSwitchActiveRouteWarningMessage = "Une tournée est actuellement en cours. Changer de mode va vous éloigner de son suivi. Continuer ?",
    modeSwitchActiveRouteWarningConfirm = "Changer quand même",
    modeSwitchActiveRouteWarningCancel = "Annuler",
)

